module.exports = {
  "zones": {
    "Asia/Thimbu": ["z", {
      "wallclock": 560044800000,
      "format": "+06",
      "abbrev": "+06",
      "offset": 21600000,
      "posix": 560025000000,
      "save": 0
    }, {
      "wallclock": -706320000000,
      "format": "+0530",
      "abbrev": "+0530",
      "offset": 19800000,
      "posix": -706341516000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 21516000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};